import { isMainnet } from '../constants'

const blastTestnetChainId = '168587773'
const blastMainnetChainId = '81457'
const baseTestnetChainId = '84532' // Base Sepolia Testnet chain ID
const baseMainnetChainId = '8453' // Base Mainnet chain ID

type TestnetChainIds = typeof blastTestnetChainId | typeof baseTestnetChainId
type MainnetChainIds = typeof baseMainnetChainId | typeof blastMainnetChainId

type SupportedChain = {
  chainId: string
  chainName: string
  nativeCurrency: {
    name: string
    symbol: string
    decimals: number
  }
  rpcUrls: string[]
  blockExplorerUrls: string[]
  iconName: string
}

export const SUPPORTED_TESTNET_CHAINS: {
  [key in TestnetChainIds]: SupportedChain
} = {
  [blastTestnetChainId]: {
    chainId: '0xa0c71fd',
    chainName: 'Blast',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://sepolia.blast.io'],
    blockExplorerUrls: ['https://testnet.blastscan.io'],
    iconName: 'blast',
  },
  [baseTestnetChainId]: {
    chainId: '0x14a34',
    chainName: 'Base',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://sepolia.base.org'],
    blockExplorerUrls: ['https://sepolia.basescan.org'],
    iconName: 'base',
  },
}

export const SUPPORTED_MAINNET_CHAINS: {
  [key in MainnetChainIds]: SupportedChain
} = {
  [blastMainnetChainId]: {
    chainId: '0x13d05',
    chainName: 'Blast',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://rpc.blast.io'],
    blockExplorerUrls: ['https://blastscan.io'],
    iconName: 'blast',
  },
  [baseMainnetChainId]: {
    chainId: '0x2105',
    chainName: 'Base',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://mainnet.base.org'],
    blockExplorerUrls: ['https://basescan.org'],
    iconName: 'base',
  },
}

export const SUPPORTED_CHAINS = isMainnet
  ? SUPPORTED_MAINNET_CHAINS
  : SUPPORTED_TESTNET_CHAINS
